export function applyOpacityToHex(hex: string, opacity: number): string {
  const strippedHex = hex.replace('#', '');
  const red = parseInt(strippedHex.substring(0, 2), 16);
  const green = parseInt(strippedHex.substring(2, 4), 16);
  const blue = parseInt(strippedHex.substring(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}

// This function was made for the use case of replacing the mui defined shadows rgba values with our own hex values
export function replaceRgbaColor(input: string, newColor = ''): string {
  if (input && newColor) {
    return input.replace(/rgba\((.*?)\)/g, newColor);
  }
  return input;
}
